__turbopack_context__.v({
  "avatar": "CardsLoader-module-scss-module__FNnFXa__avatar",
  "body": "CardsLoader-module-scss-module__FNnFXa__body",
  "card": "CardsLoader-module-scss-module__FNnFXa__card",
  "desc": "CardsLoader-module-scss-module__FNnFXa__desc",
  "header": "CardsLoader-module-scss-module__FNnFXa__header",
  "root": "CardsLoader-module-scss-module__FNnFXa__root",
  "tag": "CardsLoader-module-scss-module__FNnFXa__tag",
  "tags": "CardsLoader-module-scss-module__FNnFXa__tags",
  "title": "CardsLoader-module-scss-module__FNnFXa__title",
});
